import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { persist, devtools } from 'zustand/middleware'
import httpClient from '@/lib/httpClient'
let store = immer((set, get) => ({
  currentTeamId: null,
  isAuthenticated: false,
  userData: null,
  count: 0,
  showTwoFactorChallenge: false,
  authenticate: (val) => {
    set((state) => {
      state.isAuthenticated = val
    })
  },
  setUserData: (val) => {
    set((state) => {
      state.userData = val
    })
  },
  getAvatar: () => {
    const userData = get().userData
    return userData?.name?.charAt(0)
  },
  setCurrentTeamId: (value) => {
    set((state) => {
      state.currentTeamId = value
      httpClient.defaults.headers['X-Team'] = value
    })
  },
  increment: (qty) =>
    set((state) => {
      state.count += qty
    }),
  decrement: (qty) =>
    set((state) => {
      state.count -= qty
    }),
  setShowTwoFactorChallenge: (val) => {
    set((state) => {
      state.showTwoFactorChallenge = val
    })
  },
}))

store = devtools(store)

store = persist(store, {
  name: 'auth-store',
  getStorage: () => sessionStorage,
  partialize: (state) => ({
    ...state,
    showTwoFactorChallenge: undefined,
  }),
})

const useAuthStore = create(store)

export default useAuthStore
